<template>
  <div class="chat-room" :style="{ backgroundImage: `url(${characterInfo.chatBgImage})`}">
    <Navigator @setting="setting"/>
    <MsgList
      ref="msgList"
      :msgList="messageList"
      :characterInfo="characterInfo"
      @getHistory="getHistory"
      @updateSelfies="handleUpdateSelfies"
      @updateVideos="handleUpdateVideos"
    />
    <div class="tool">
      <div class="btn selfies-btn" @click="getSelfies">Selfies</div>
      <div class="btn" @click="getVideos">Videos</div>
    </div>
    <MsgInput @send="send"/>
    <Tool v-if="showTool" @close="showTool=false" />
  </div>
</template>

<script>
import {
  createSession, getCharacterById, sendMessage, getLockedSelfies, unlockSelfies, getSelfies, getLockedVideos, unlockVideos, getVideos,
} from '@/api';
import { mapActions, mapGetters } from 'vuex';
import { debounce } from '@/utils';
import chatSession from '@/utils/chatSession';
import MsgInput from './components/MsgInput';
import MsgList from './components/MsgList';
import Navigator from './components/Navigator';
import Tool from './components/Tool';

export default {
  components: {
    Navigator,
    MsgList,
    MsgInput,
    Tool,
  },
  data() {
    return {
      page: 1,
      characterInfo: {},
      messageList: [],
      showTool: false,
    };
  },
  computed: {
    ...mapGetters([
      'userInfo',
    ]),
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions(['updateMessageLimit', 'updateCoin']),
    async init() {
      const { characterId } = this.$route.params || {};
      if (!characterId) return;
      this.characterId = characterId;
      // 获取缓存
      const {
        list = [], sessionId, avatar = '', description = '', chatBgImage = '',
      } = this.getChatInfo();
      this.characterInfo = {
        characterId,
        sessionId,
        avatar,
        description,
        chatBgImage,
      };
      if (list.length) {
        this.messageList = list;
        this.sessionId = sessionId;
        return;
      }

      this.initSession();
    },
    async initSession() {
      try {
        const { characterId } = this;
        const [sessionRes, characterRes] = await Promise.all([
          createSession(characterId),
          getCharacterById(characterId),
        ]);
        if (sessionRes.code !== 0 || characterRes.code !== 0) return;
        // session信息
        const { first_message: greeting, session_id: sessionId } = sessionRes.data || {};
        if (!sessionId) return;
        this.sessionId = sessionId;

        // 打招呼
        if (!greeting) return;
        const greetingInfo = {
          msgType: 'greeting',
          type: 'text',
          content: greeting,
        };
        // 人物信息
        const { name: characterName = '', avatar = '', description = '' } = characterRes?.data?.character || {};
        const characterInfo = {
          characterName,
          characterId,
          sessionId,
          avatar,
          description,
        };
        this.characterInfo = characterInfo;
        chatSession.storeChat(characterId, greetingInfo, characterInfo);
        this.messageList = [greetingInfo];
      } catch (error) {
        console.log('error------', error);
      }
    },
    getChatInfo() {
      return chatSession.getChatInfo(this.characterId, this.page);
    },
    setting() {
      this.showTool = true;
    },
    async handleUpdateVideos(item) {
      const { price, video_id } = item;
      if (this.userInfo.coin < price) { // 不够钱的时候显示上锁信息
        this.goTopUp();
        return;
      }
      const res = await unlockVideos(video_id);
      if (res.code !== 0 && res.message !== 'ok') {
        this.$toast.error('unlock failed, please try later...');
      } else {
        const { coin } = res.data || {};
        this.updateCoin(coin);
        debugger;
        const videosRes = await getVideos(this.characterInfo.characterId);
        const unlockList = videosRes?.data?.videos || [];
        chatSession.updateUnlockVideo(this.characterInfo.characterId, unlockList);
        window.location.reload();
      }
    },
    async handleUpdateSelfies(item) {
      const { price, selfie_id } = item;
      if (this.userInfo.coin < price) { // 不够钱的时候显示上锁信息
        this.goTopUp();
        return;
      }
      const res = await unlockSelfies(selfie_id);
      if (res.code !== 0 && res.message !== '已解锁该自拍') {
        this.$toast.error('unlock failed, please try later...');
      } else {
        const { coin } = res.data || {};
        this.updateCoin(coin);
        const selfiesRes = await getSelfies(this.characterInfo.characterId);
        const unlockList = selfiesRes?.data?.selfies || [];
        chatSession.updateUnlockImage(this.characterInfo.characterId, unlockList);
        window.location.reload();
      }
    },
    goTopUp: debounce(function goTopUp() {
      this.$toast.error('Insufficient Balance');
      const t = setTimeout(() => {
        clearTimeout(t);
        this.$router.push('/topup');
      }, 300);
    }, 500, true),
    async getVideos() {
      const loading = this.$loading({
        backgroundColor: 'rgba(32, 37, 36, 0.3)',
      });
      const res = await getLockedVideos(this.sessionId);
      // 没有未解锁的视频时
      const data = res?.data || {};
      loading.close();
      if (!data?.messages?.length) {
        this.$toast.error('All videos sent');
        return;
      }
      const { video_id, price } = data?.messages?.[0] || {};
      let responseMsg = {};
      if (this.userInfo.coin < price) { // 不够钱的时候显示上锁信息
        responseMsg = {
          type: 'lock',
          msgType: 'video',
          content: '',
          video_id,
          price,
        };
        this.messageList.push(responseMsg);
        chatSession.storeChat(this.characterId, responseMsg);
        return;
      }
      responseMsg = {
        type: 'text',
        msgType: 'loading',
        content: '',
      };
      this.messageList.push(responseMsg);
      const unlockRes = await unlockVideos(video_id).catch((err) => err);
      if (unlockRes.code !== 0) {
        responseMsg.msgType = 'timeout';
        chatSession.storeChat(this.characterId, responseMsg);
        return;
      }
      const { video: content = '', coin } = unlockRes.data || {};
      coin && coin !== 0 && this.updateCoin(coin);
      // 修改预存的信息
      Object.assign(responseMsg, {
        content,
        type: 'unlock',
        msgType: 'video',
      });
      // 存储
      chatSession.storeChat(this.characterId, responseMsg);
    },
    async getSelfies() {
      const loading = this.$loading({
        backgroundColor: 'rgba(32, 37, 36, 0.3)',
      });
      const res = await getLockedSelfies(this.sessionId);
      // 没有未解锁的自拍时
      const data = res?.data || {};
      loading.close();
      if (!data?.messages?.length) {
        this.$toast.error('All selfies sent');
        return;
      }
      const { selfie_id, price } = data?.messages?.[0] || {};
      let responseMsg = {};
      if (this.userInfo.coin < price) { // 不够钱的时候显示上锁信息
        responseMsg = {
          type: 'lock',
          msgType: 'selfie',
          content: '',
          selfie_id,
          price,
        };
        this.messageList.push(responseMsg);
        chatSession.storeChat(this.characterId, responseMsg);
        return;
      }
      responseMsg = {
        type: 'text',
        msgType: 'loading',
        content: '',
      };
      this.messageList.push(responseMsg);
      const unlockRes = await unlockSelfies(selfie_id).catch((err) => err);
      if (unlockRes.code !== 0) {
        responseMsg.msgType = 'timeout';
        chatSession.storeChat(this.characterId, responseMsg);
        return;
      }
      const { url: content = '', coin } = unlockRes.data || {};
      coin && coin !== 0 && this.updateCoin(coin);
      // 修改预存的信息
      Object.assign(responseMsg, {
        content,
        type: 'unlock',
        msgType: 'selfie',
      });
      // 存储
      chatSession.storeChat(this.characterId, responseMsg);
    },
    getHistory(done) {
      this.page++;
      const { list } = this.getChatInfo();
      if (list && list.length) {
        this.messageList = list.concat(this.messageList);
      }
      done && done();
    },
    async handleMessageDisplay(messages) {
      const messageArr = [];
      const typeMap = {
        'text': 'aiMsg',
        'img': 'selfie',
      };
      const mes = messages.map(async (item) => {
        const singleMessage = {
          ...item,
        };
        if (item.type === 'img') {
          if (this.userInfo.coin < item.price) { // 不够钱的时候显示上锁信息
            singleMessage.type = 'lock';
          } else {
            const unlockRes = await unlockSelfies(item.selfie_id).catch((err) => err);
            if (unlockRes.code !== 0) return;
            const { url = '', coin } = unlockRes.data || {};
            this.updateCoin(coin);
            singleMessage.content = url;
          }
        }
        singleMessage.msgType = typeMap[item.type];
        messageArr.push(singleMessage);
      });
      await Promise.all(mes);
      return messageArr;
    },
    async send(content) {
      // 发送的信息
      const msg = {
        type: 'text',
        msgType: 'ownMsg',
        content,
        msgFrom: 'self',
      };
      this.messageList.push(msg);
      // 预存返回的信息
      const responseMsg = ({
        type: 'text',
        msgType: 'loading',
        content: '',
      });
      this.messageList.push(responseMsg);
      // 请求
      const res = await sendMessage(this.sessionId, content).catch((err) => err);
      if (res.code !== 0) {
        if (res.message.includes('timeout') || res.message === 'Network Error') { // 超时提示
          responseMsg.msgType = 'timeout';
          chatSession.storeChat(this.characterId, msg);
          chatSession.storeChat(this.characterId, responseMsg);
        }
        return;
      }
      const { messages = [], message_limit } = res.data || {};
      if (messages?.[0]?.content === 'Insufficient message quota') {
        this.$toast('Insufficient message quota');
        setTimeout(() => {
          this.$router.push('/premium');
        }, 1000);
        return;
      }
      this.updateMessageLimit(message_limit);
      const messageList = await this.handleMessageDisplay(messages);
      // 修改预存的信息
      Object.assign(responseMsg, messageList[0] || {});
      // 存储
      chatSession.storeChat(this.characterId, msg);
      chatSession.storeChat(this.characterId, responseMsg);
      if (messageList.length > 1) {
        this.messageList.push(messageList[1]);
        chatSession.storeChat(this.characterId, messageList[1]);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.chat-room {
  position: relative;
  height: 100%;
  // padding: 0 12px;
  background-color: #f2f2f2;
  display: flex;
  flex-direction: column;
  background-size: cover;
  background-position: center center;
  .msg-list {
    flex: 1;
  }
  /* background-color: red; */
  .tool {
    position: absolute;
    left: 16px;
    bottom: 105px;
    display: flex;
    align-items: center;
  }
  .btn {
    padding: 0 12px 0 40px;
    background: url('@/assets/images/icon/videos.png') rgba(255, 255, 255, 0.6) 12px center no-repeat;
    background-size: 20px 20px;
    height: 32px;
    line-height: 32px;
    border-radius: 18px;
  }
  .selfies-btn {
    background: url('@/assets/images/icon/selfies.png') rgba(255, 255, 255, 0.6) 12px center no-repeat;
    background-size: 20px 20px;
    margin-right: 12px;
  }
}

</style>
